/* eslint-disable react/jsx-no-bind */
/* eslint-disable require-jsdoc */
import React from 'react';
import PropTypes from 'prop-types';
import AbstractButton from './AbstractButton';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { GroupsIcon } from 'assets/images';
import { translate } from 'store/modules/base/i18n';
import { connect } from 'store/modules/base/redux';
import { toggleGroups } from 'store/modules/settings';

/**
 * Implements an {@link AbstractButton} to open the user documentation in a new window.
 */
class GroupsButton extends AbstractButton {
  accessibilityLabel = 'toolbar.accessibilityLabel.groups';
  icon = GroupsIcon;
  label = 'toolbar.groups';
  type = 'yellow';

  // tooltip = 'toolbar.groups';

  /**
   * Handles clicking / pressing the button, and opens a new window with the user documentation.
   *
   * @private
   * @returns {void}
   */
  _handleClick() {
    this.props.dispatch(toggleGroups(!this.props.open));
  }
}

/**
 * Maps part of the redux state to the component's props.
 *
 * @param {Object} state - The redux store/state.
 * @returns {Object}
 */
function _mapStateToProps(state) {
  //   const enabled = getFeatureFlag(state, HELP_BUTTON_ENABLED, true);
  //   const visible = typeof userDocumentationURL === 'string' && enabled;

  return {
    visible: true,
    open: state['features/settings'].conferenceGroups,
    _userIdleMode: state['features/settings'].userIdleMode
  };
}

GroupsButton.propTypes = {
  /**
   * The URL to the user documentation.
   */
  _userDocumentationURL: PropTypes.string,
  showLabel: PropTypes.bool,
  open: PropTypes.bool
};
export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(GroupsButton)))
);
